<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h">CAIRN-ON-THE-HUDSON, NEW YORK</p>
<p class="part-title"><i>Two Years Later</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?2c8de978